import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-keyaccount-dropdown',
  templateUrl: './KeyAccountDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => KeyAccountDropdownComponent)}]
})
export class KeyAccountDropdownComponent extends BaseDropdownComponent {

    @Output() public onKeyAccountChange = new EventEmitter<ent.KeyAccount>();
        
    keyAccounts: ent.KeyAccount[] = [];

    constructor(private domainDataService: serv.DomainDataService) 
    {
        super();
    }


    ngOnInit(): void {
    }

    public load(){

        var filter: filters.KeyAccountFilter = {};
        this.domainDataService.getKeyAccounts(filter).subscribe(x=> this.onGetKeyAccountsDone(x));
    }
    
    onGetKeyAccountsDone(items: ent.KeyAccount[]){
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.FullName, value:y.ID}));
        items.forEach(y=> this.keyAccounts.push(y));
        if (this.selectedID){
            this.value = this.selectedID;
        }
        else{
            if (this.selectDefault){
                var defaultItems = items.filter(x=>x.Code == Constants._DEFAULT_KEY_ACCOUNT_CODE);
                if (defaultItems.length > 0){
                    this.value = defaultItems[0].ID;
                    this.onKeyAccountChange.emit(defaultItems[0]);
                }
            }
        }
        this.loadDone.emit(this.value);
    }

    onChange(event: any){

        var keyAccount = this.keyAccounts.filter(x=>x.ID == event.value)[0];
        if (!keyAccount){
            keyAccount = {Code: "", Inactive: false, Name: "", FullName: "", ID: Constants._NONE, PrimaryFranchiseGroup: ""};
        }

        this.onKeyAccountChange.emit(keyAccount);
    }

}